import React, { useState, useRef, useEffect } from "react";
import { Calendar, Search, ChevronDown, ChevronUp } from "lucide-react";
import DatePicker from "react-datepicker";
import {
  check_vaild_save,
  combiled_form_data,
  handleSuccessShow,
  handleError,
} from "../../CommonJquery/CommonJquery";
import {
  server_post_data,
  update_payment,
} from "../../ServiceConnection/serviceconnection.js";
import DummyDriver from "../../assets/dummyDriver.jpeg";
import Loader from "../Loader.js";

const PaymentEntry = ({
  activeSection,
  driverData,
  master_data_getDriverData,
  master_data_get,
  selectedDriverId,
  selectedDriverBookingId,
  startDateAll,
  endDateAll,
  dateRangeType,
}) => {
  const [startDate, setStartDate] = useState(new Date());
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [isDriverDropdownOpen, setIsDriverDropdownOpen] = useState(false);
  const [driverSearchQuery, setDriverSearchQuery] = useState("");
  const [paymentMode, setpaymentMode] = useState("");
  const [bookingType, setbookingType] = useState("1");
  const [ledger_data, set_ledger_data] = useState("");
  const [deposit, setdeposit] = useState(0);
  const [rent, setrent] = useState(0);
  const [tolls, settolls] = useState(0);
  const [damage, setdamage] = useState(0);
  const [ticket, setticket] = useState(0);
  const [letfees, setletfees] = useState(0);
  const [letotherchr, setotherchr] = useState(0);
  // const [deposit, setdeposit] = useState('')
  const [discount, setdiscount] = useState("");
  const [notes, setnotes] = useState("");
  const [totalamount, settotalamount] = useState("");
  const driverDropdownRef = useRef(null);

  const [error, setError] = useState("");

  useEffect(() => {
    const depositValue = parseInt(deposit) || 0;
    const rentValue = parseInt(rent) || 0;
    const tollsValue = parseInt(tolls) || 0;
    const damageValue = parseInt(damage) || 0;
    const ticketValue = parseInt(ticket) || 0;
    const letfeesValue = parseInt(letfees) || 0;
    const letotherchrValue = parseInt(letotherchr) || 0;
    // const depositValue = parseInt(deposit) || 0;

    settotalamount(
      depositValue +
        rentValue +
        tollsValue +
        damageValue +
        ticketValue +
        letfeesValue +
        letotherchrValue
    );
  }, [deposit, rent, tolls, damage, ticket, letfees, letotherchr]);
  // Add click outside listener to close dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        driverDropdownRef.current &&
        !driverDropdownRef.current.contains(event.target)
      ) {
        setIsDriverDropdownOpen(false);
      }
    }

    // Add event listener if dropdown is open
    if (isDriverDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Cleanup the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDriverDropdownOpen]);

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);

    if (vaild_data) {
      const totalAmtText = document.querySelector(".totlamt").textContent;
      const totalAmt = parseFloat(totalAmtText.replace(/[^0-9.-]/g, ""));
      // console.log(totalAmt);
      if (totalAmt <= 0) {
        alert("Total amount must be greater than zero.");
        return;
      }
      if (selectedDriver == null) {
        alert("select Driver");
        return;
      }
      if (totalamount <= 0) {
        alert("Total amount must be greater than zero.");
        return;
      }

      if (!paymentMode) {
        alert("Please Select Payment Mode");
        return;
      }

      // if (!bookingType) {
      //   alert("Please Select Booking Type");
      //   return;
      // }

      //console.log(" go");
      setshowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, null);
      if (bookingType == "1") {
        fd_from.append("booking_id", selectedDriver?.booking_data?.primary_id);
        fd_from.append("car_id", selectedDriver?.booking_data?.car_id);
        fd_from.append(
          "contract_id",
          selectedDriver?.booking_data?.contract_id
        );
      }
      if (bookingType == "2") {
        fd_from.append(
          "booking_id",
          selectedDriver?.old_booking_data?.primary_id
        );
        fd_from.append("car_id", selectedDriver?.old_booking_data?.car_id);
        fd_from.append(
          "contract_id",
          selectedDriver?.old_booking_data?.contract_id
        );
      }
      // fd_from.append("car_id", selectedDriver?.booking_data?.car_id);
      // fd_from.append("contract_id", selectedDriver?.booking_data?.contract_id);
      fd_from.append("user_id", selectedDriver.primary_id);
      fd_from.append("payment_date", formatDate(startDate));
      fd_from.append("transaction_note", notes);
      fd_from.append("payment_status", 1);
      fd_from.append("payment_mode", paymentMode);
      fd_from.append("booking_type", bookingType);
      fd_from.append("entry_from", 2);
      // fd_from.append("payment_mode", paymentMode);
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            setStartDate(new Date());
            setshowLoaderAdmin(false);
            setSelectedDriver(null);
            setIsDriverDropdownOpen(false);
            setpaymentMode("");
            set_ledger_data("");
            setdeposit(0);
            setrent(0);
            settolls(0);
            setdamage(0);
            setticket(0);
            setletfees(0);
            setotherchr(0);
            setdiscount("");
            setnotes("");
            settotalamount("");
            setpaymentMode("");
            setbookingType("");
            // handleSuccessSession(Response.data.message);
            handleSuccessShow("Successfully Saved!");
            master_data_getDriverData();
            master_data_get(
              startDateAll,
              endDateAll,
              2,
              dateRangeType,
              selectedDriverId,
              selectedDriverBookingId
            );
          }
        })
        .catch((error) => {
          setshowLoaderAdmin(false);
          handleError("network");
        });
    }
  };
  function formatDate(dateObj) {
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObj.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  const handleSelectDriver = (driver) => {
    setSelectedDriver(driver);
    // console.log(driver);
    setIsDriverDropdownOpen(false);
    setDriverSearchQuery("");
    // You can add additional logic here to load transactions for the selected driver
  };

  // Fix: Only search by name and ID (which exists in the driver objects)
  const filteredDrivers = driverData
    ? driverData.filter(
        (driver) =>
          (driver.name ? driver.name.toLowerCase() : "").includes(
            driverSearchQuery.toLowerCase()
          ) ||
          (driver.primary_id
            ? driver.primary_id.toString().toLowerCase()
            : ""
          ).includes(driverSearchQuery.toLowerCase())
      )
    : [];

  return (
    <>
      {showLoaderAdmin && <Loader />}
      <section
        id="payment-entry"
        className={`accounting-section ${
          activeSection === "payment-entry" ? "" : "accounting-hidden"
        }`}
      >
        {/* <div className="accounting-section-header">
          <h2 className="accounting-section-title">Payment Entry</h2>
          <div className="accounting-header-actions"></div>
        </div> */}

        <div className="accounting-payment-form">
          <div className="accounting-payment-header">
            <div className="accounting-payment-fields">
              <div
                className="accounting-filter-group"
                style={{ paddingTop: "2px" }}
              >
                <label htmlFor="start-date" className="accounting-label">
                  Date
                </label>
                <div className="accounting-date-input-wrapper">
                  <DatePicker
                    id="start-date"
                    name="start-date"
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    className="accounting-date-input borderRadiusnew mt-0"
                    placeholderText="MM/DD/YYYY"
                    dateFormat="MM/dd/yyyy"
                    maxDate={new Date()}
                    minDate={new Date()}
                  />
                  <Calendar className="accounting-date-icon" size={18} />
                </div>
              </div>

              <div className="accounting-payment-field">
                <label htmlFor="payment-mode" className="accounting-label">
                  Payment Mode
                </label>
                <select
                  id="payment-mode"
                  name="payment-mode"
                  className="accounting-select"
                  value={paymentMode}
                  onChange={(e) => setpaymentMode(e.target.value)}
                >
                  <option value="" disabled hidden>
                    Select Payment Mode
                  </option>
                  <option value="cash">Cash</option>
                  <option value="stripe">Stripe</option>
                  <option value="zelle">Zelle</option>
                </select>
              </div>

              {/* <div className="accounting-payment-field">
                <label htmlFor="payment-mode" className="accounting-label">
                  Booking Type
                </label>
                <select
                  id="payment-mode"
                  name="payment-mode"
                  className="accounting-select"
                  value={bookingType}
                  onChange={(e) => setbookingType(e.target.value)}
                >
                  <option value="" disabled hidden>
                    Select Booking Type
                  </option>
                  <option value="1">Active</option>
                  <option value="2">Dropped</option>
                </select>
              </div> */}

              <div className="accounting-payment-field">
                <label htmlFor="select-driver" className="accounting-label">
                  Select Driver
                </label>
                <div className="position-relative" ref={driverDropdownRef}>
                  <div
                    className="form-floating form-control shadow-sm d-flex justify-content-between align-items-center cursor-pointer"
                    onClick={() =>
                      setIsDriverDropdownOpen(!isDriverDropdownOpen)
                    }
                    style={{
                      cursor: "pointer",
                      height: "40px",
                      paddingTop: "10px",
                      marginTop: "6px",
                    }}
                  >
                    {selectedDriver ? (
                      <div className="fw-medium">{selectedDriver.name}</div>
                    ) : (
                      <div className="">Choose a driver</div>
                    )}
                    <div
                      className="position-absolute"
                      style={{
                        bottom: "6px",
                        right: "10px",
                        pointerEvents: "none",
                      }}
                    >
                      {isDriverDropdownOpen ? (
                        <ChevronUp size={16} />
                      ) : (
                        <ChevronDown size={16} />
                      )}
                    </div>
                  </div>

                  {isDriverDropdownOpen && (
                    <div
                      className="position-absolute w-100 bg-white shadow-lg rounded-bottom z-index-1000"
                      style={{ zIndex: 1000 }}
                    >
                      <div className="p-2 border-bottom">
                        <div className="input-group">
                          <span
                            className="input-group-text bg-white border-end-0"
                            style={{ marginTop: "5px" }}
                          >
                            <Search size={16} />
                          </span>
                          <input
                            type="text"
                            className="form-control border-start-0"
                            placeholder="Search by name or ID..."
                            value={driverSearchQuery}
                            onChange={(e) => {
                              setDriverSearchQuery(e.target.value);
                              console.log("yes this one");
                              console.log(e.target.value);
                            }}
                            autoFocus
                          />
                        </div>
                      </div>
                      <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                        {filteredDrivers.length > 0 ? (
                          filteredDrivers.map((driver) => (
                            <div
                              key={driver.primary_id}
                              className="p-2 border-bottom hover-bg-light cursor-pointer"
                              // onClick={() => handleSelectDriver(driver)}
                              onClick={() => {
                                const booking = driver?.booking_data;
                                console.log("mk", booking);

                                if (!booking) {
                                  alert("This driver has no booking.");
                                  setSelectedDriver(null);
                                  return;
                                }

                                const step = booking.step_for_booking;
                                const switchType = booking.payment_cycle_switch;

                                if (
                                  step === "5" &&
                                  ["1", "2", "3"].includes(switchType)
                                ) {
                                  alert(
                                    "This driver has no active booking. The last booking was a switched booking."
                                  );
                                  setSelectedDriver(null);
                                  return;
                                }

                                if (step === "6") {
                                  alert(
                                    "Please complete the last booking switch process before continuing."
                                  );
                                  setSelectedDriver(null);
                                  return;
                                }

                                if (step === "7") {
                                  alert(
                                    "Please complete the last booking repo process before continuing."
                                  );
                                  setSelectedDriver(null);
                                  return;
                                }

                                if (["0", "1", "2", "3"].includes(step)) {
                                  alert(
                                    "This driver has a booking in progress but it is not active yet."
                                  );
                                  setSelectedDriver(null);
                                  return;
                                }

                                if (["9", "10"].includes(step)) {
                                  alert(
                                    "The last booking was either rejected or canceled."
                                  );
                                  setSelectedDriver(null);
                                  return;
                                }

                                handleSelectDriver(driver);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <div className="fw-medium">{driver.name}</div>
                              <div className="small text-muted">
                                ID: {driver.primary_id}
                                {/* - Outstanding:{" "}
                              {driver.outstanding} */}
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="p-3 text-center text-muted">
                            No drivers found
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {selectedDriver != null && (
              <div className="accounting-driver-profile">
                <div className="accounting-driver-avatar-container">
                  <img
                    // src={
                    //   selectedDriver.user_image &&
                    //     selectedDriver.user_image.trim() !== "" &&
                    //     selectedDriver.user_image.trim().toLowerCase() !==
                    //     "null"
                    //     ? imageLink + selectedDriver.user_image
                    //     : "https://avatar.iran.liara.run/public/36"
                    // }
                    src={DummyDriver}
                    alt="Driver Photo"
                    className="accounting-driver-avatar-large"
                  />
                </div>
                <div>
                  <h3 className="accounting-driver-name-large">
                    {selectedDriver.name}{" "}
                    {selectedDriver?.old_booking_data?.payment_cycle_switch ==
                      "1" && <span className="newTagPAy">I-Pass Switched</span>}
                    {selectedDriver?.old_booking_data?.payment_cycle_switch ==
                      "2" && <span className="newTagPAy">Car Switched</span>}
                  </h3>
                  <p className="accounting-driver-details m-0">
                    Outstanding: $
                    {bookingType == "1"
                      ? selectedDriver?.booking_data?.total_due ?? 0
                      : selectedDriver?.old_booking_data?.total_due ?? 0}
                  </p>
                </div>
              </div>
            )}
          </div>
          <form className="createRightsForm" id="createRightsForm">
            <div className="accounting-services-due">
              <div className="accounting-services-header">
                <h3 className="accounting-services-title">Services Due</h3>
              </div>

              <div className="accounting-services-list">
                {/* <div className="accounting-service-item">
                  <div className="accounting-service-info">
                    <div className="accounting-service-checkbox">
                      <label
                        htmlFor="rent_amount"
                        className="accounting-service-label"
                      >
                        <span className="accounting-service-name">Deposit</span>
                      </label>
                    </div>
                  </div>

                  <div className="accounting-service-amount">
                    <span className="accounting-amount-due">
                      {bookingType == "1"
                        ? selectedDriver?.booking_data?.due_deposit ?? 0
                        : selectedDriver?.old_booking_data?.due_deposit ?? 0}
                    </span>

                    <input
                      type="number"
                      id="deposit"
                      name="deposit"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={deposit}
                      onChange={(e) => {
                        const newValue = e.target.value;

                        if (newValue === "" || isNaN(Number(newValue))) {
                          setdeposit(newValue);
                          return;
                        }

                        const enteredDeposit = Number(newValue);
                        const totalDeposit = Number(
                          selectedDriver?.booking_data?.due_deposit || 0
                        );

                        if (enteredDeposit < 0) {
                          e.preventDefault();
                          alert("Damage amount cannot be negative.");
                        } else if (enteredDeposit <= totalDeposit) {
                          setdamage(newValue);
                        } else {
                          e.preventDefault();
                          alert(
                            `Entered damage fee cannot be more than due amount ($${totalDeposit})`
                          );
                        }
                      }}
                    />
                  </div>
                </div> */}
                <div className="accounting-service-item">
                  <div className="accounting-service-info">
                    <div className="accounting-service-checkbox">
                      <label
                        htmlFor="rent_amount"
                        className="accounting-service-label"
                      >
                        <span className="accounting-service-name">Rent</span>
                      </label>
                    </div>
                  </div>

                  <div className="accounting-service-amount">
                    <span className="accounting-amount-due">
                      {/* ${selectedDriver?.booking_data?.due_rent || 0} */}$
                      {bookingType == "1"
                        ? selectedDriver?.booking_data?.due_rent ?? 0
                        : selectedDriver?.old_booking_data?.due_rent ?? 0}
                    </span>

                    <input
                      type="number"
                      id="rent"
                      name="rent"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={rent}
                      onChange={(e) => {
                        const newValue = e.target.value;

                        // If input is empty or not a number, just update
                        if (newValue === "" || isNaN(Number(newValue))) {
                          setrent(newValue);
                          return;
                        }

                        const enteredRent = Number(newValue);
                        const totalRent = Number(
                          selectedDriver?.booking_data?.due_rent || 0
                        );

                        // Only update state if value is valid
                        if (enteredRent >= 0) {
                          setrent(newValue);
                        } else {
                          // For invalid values, show alert but don't update state
                          e.preventDefault(); // Prevent default behavior
                          alert("Rent cannot be less than zero.");
                          // Keep the previous value by not calling setRent
                        }
                      }}
                    />
                  </div>
                </div>

                <div className="accounting-service-item">
                  <div className="accounting-service-info">
                    <div className="accounting-service-checkbox">
                      <label
                        htmlFor="tolls_amount"
                        className="accounting-service-label"
                      >
                        <span className="accounting-service-name">Tolls</span>
                      </label>
                    </div>
                  </div>

                  <div className="accounting-service-amount">
                    <span className="accounting-amount-due">
                      {/* ${selectedDriver?.booking_data?.due_tolls || 0} */}$
                      {bookingType == "1"
                        ? selectedDriver?.booking_data?.due_tolls ?? 0
                        : selectedDriver?.old_booking_data?.due_tolls ?? 0}
                    </span>

                    <input
                      type="number"
                      id="tolls"
                      name="tolls"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={tolls} // Changed from defaultValue to value for controlled input
                      onChange={(e) => {
                        const newValue = e.target.value;

                        // If input is empty or not a number, just update
                        if (newValue === "" || isNaN(Number(newValue))) {
                          settolls(newValue);
                          return;
                        }

                        const enteredTolls = Number(newValue);
                        const totalTolls = Number(
                          bookingType == "1"
                            ? selectedDriver?.booking_data?.due_tolls
                            : selectedDriver?.old_booking_data?.due_tolls || 0
                        ); // Adjust to your actual total tolls property

                        // Only update state if value is valid
                        if (enteredTolls < 0) {
                          e.preventDefault();
                          alert("Toll amount cannot be negative.");
                          // } else if (enteredTolls <= totalTolls) {
                        } else {
                          settolls(newValue);
                        }
                        // else {
                        //   // For invalid values, show alert but don't update state
                        //   e.preventDefault(); // Prevent default behavior
                        //   alert(
                        //     `Entered tolls cannot be more than due amount ($${totalTolls})`
                        //   );
                        //   // Keep the previous value by not calling setTolls
                        // }
                      }}
                    />
                  </div>
                </div>

                <div className="accounting-service-item">
                  <div className="accounting-service-info">
                    <div className="accounting-service-checkbox">
                      <label
                        htmlFor="damage"
                        className="accounting-service-label"
                      >
                        <span className="accounting-service-name">Damage</span>
                      </label>
                    </div>
                  </div>

                  <div className="accounting-service-amount">
                    <span className="accounting-amount-due">
                      {/* ${selectedDriver?.booking_data?.due_damage || 0} */}$
                      {bookingType == "1"
                        ? selectedDriver?.booking_data?.due_damage ?? 0
                        : selectedDriver?.old_booking_data?.due_damage ?? 0}
                    </span>
                    <input
                      type="number"
                      id="damage"
                      name="damage"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={damage} // Changed from defaultValue to value for controlled input
                      onChange={(e) => {
                        const newValue = e.target.value;

                        // If input is empty or not a number, just update
                        if (newValue === "" || isNaN(Number(newValue))) {
                          setdamage(newValue);
                          return;
                        }

                        const enteredDamage = Number(newValue);
                        const totalDamage = Number(
                          bookingType == "1"
                            ? selectedDriver?.booking_data?.due_damage
                            : selectedDriver?.old_booking_data?.due_damage || 0
                        );

                        // Only update state if value is valid
                        if (enteredDamage < 0) {
                          e.preventDefault();
                          alert("Damage amount cannot be negative.");
                        } else if (enteredDamage <= totalDamage) {
                          setdamage(newValue);
                        } else {
                          // For invalid values, show alert but don't update state
                          e.preventDefault(); // Prevent default behavior
                          alert(
                            `Entered damage fee cannot be more than due amount ($${totalDamage})`
                          );
                          // Keep the previous value by not calling setDamage
                        }
                      }}
                    />
                  </div>
                </div>

                <div className="accounting-service-item">
                  <div className="accounting-service-info">
                    <div className="accounting-service-checkbox">
                      <label
                        htmlFor="tickets"
                        className="accounting-service-label"
                      >
                        <span className="accounting-service-name">Tickets</span>
                      </label>
                    </div>
                  </div>

                  <div className="accounting-service-amount">
                    <span className="accounting-amount-due">
                      {/* ${selectedDriver?.booking_data?.due_ticket || 0} */}$
                      {bookingType == "1"
                        ? selectedDriver?.booking_data?.due_ticket ?? 0
                        : selectedDriver?.old_booking_data?.due_ticket ?? 0}
                    </span>
                    {/* <span className="accounting-amount-due">${selectedDriver?.booking_data?.due_ticket || 0}</span> */}
                    <input
                      type="number"
                      id="tickets"
                      name="tickets"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={ticket} // Changed from defaultValue to value for controlled input
                      onChange={(e) => {
                        const newValue = e.target.value;

                        // If input is empty or not a number, just update
                        if (newValue === "" || isNaN(Number(newValue))) {
                          setticket(newValue);
                          return;
                        }

                        const enteredTicket = Number(newValue);
                        const totalTickets = Number(
                          bookingType == "1"
                            ? selectedDriver?.booking_data?.due_ticket
                            : selectedDriver?.old_booking_data?.due_ticket || 0
                        );

                        // Only update state if value is valid
                        if (enteredTicket < 0) {
                          e.preventDefault();
                          alert("Ticket amount cannot be negative.");
                        } else if (enteredTicket <= totalTickets) {
                          setticket(newValue);
                        } else {
                          // For invalid values, show alert but don't update state
                          e.preventDefault(); // Prevent default behavior
                          alert(
                            `Entered ticket amount cannot be more than due amount ($${totalTickets})`
                          );
                          // Keep the previous value by not calling setTicket
                        }
                      }}
                    />
                  </div>
                </div>

                <div className="accounting-service-item" hidden>
                  <div className="accounting-service-info">
                    <div className="accounting-service-checkbox">
                      <label
                        htmlFor="latefees"
                        className="accounting-service-label"
                      >
                        <span className="accounting-service-name">
                          Late Fees
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="accounting-service-amount">
                    <span className="accounting-amount-due">
                      {/* ${selectedDriver?.booking_data?.due_latefees || 0} */}
                      $
                      {bookingType == "1"
                        ? selectedDriver?.booking_data?.due_latefees ?? 0
                        : selectedDriver?.old_booking_data?.due_latefees ?? 0}
                    </span>
                    <input
                      type="number"
                      id="latefees"
                      name="latefees"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={letfees}
                      onChange={(e) => {
                        const newValue = e.target.value;

                        // If input is empty or not a number, just update
                        if (newValue === "" || isNaN(Number(newValue))) {
                          setletfees(newValue);
                          return;
                        }

                        const enteredLateFees = Number(newValue);
                        const totalLateFees = Number(
                          bookingType == "1"
                            ? selectedDriver?.booking_data?.due_latefees ?? 0
                            : selectedDriver?.old_booking_data?.due_latefees ??
                                0
                        );

                        // Only update state if value is valid
                        if (enteredLateFees < 0) {
                          e.preventDefault();
                          alert("LateFees amount cannot be negative.");
                        } else if (enteredLateFees <= totalLateFees) {
                          setletfees(newValue);
                        } else {
                          // For invalid values, show alert but don't update state
                          e.preventDefault(); // Prevent default behavior
                          alert(
                            `Entered late fees cannot be more than due amount ($${totalLateFees})`
                          );
                          // Keep the previous value by not calling setLetfees
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="accounting-service-item">
                  <div className="accounting-service-info">
                    <div className="accounting-service-checkbox">
                      <label
                        htmlFor="latefees"
                        className="accounting-service-label"
                      >
                        <span className="accounting-service-name">
                          Other Charges
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="accounting-service-amount">
                    <span className="accounting-amount-due">
                      {/* ${selectedDriver?.booking_data?.due_other_charges || 0} */}
                      $
                      {bookingType == "1"
                        ? selectedDriver?.booking_data?.due_other_charges ?? 0
                        : selectedDriver?.old_booking_data?.due_other_charges ??
                          0}
                    </span>
                    <input
                      type="number"
                      id="otherCharge"
                      name="otherCharge"
                      className="accounting-amount-input"
                      placeholder="Amount"
                      value={letotherchr}
                      onChange={(e) => {
                        const newValue = e.target.value;

                        // If input is empty or not a number, just update
                        if (newValue === "" || isNaN(Number(newValue))) {
                          setotherchr(newValue);
                          return;
                        }

                        const enteredother_charges = Number(newValue);
                        const totalother_charges = Number(
                          bookingType == "1"
                            ? selectedDriver?.booking_data?.due_other_charges
                            : selectedDriver?.old_booking_data
                                ?.due_other_charges || 0
                        );

                        // Only update state if value is valid
                        if (enteredother_charges < 0) {
                          e.preventDefault();
                          alert("other charges amount cannot be negative.");
                        } else if (enteredother_charges <= totalother_charges) {
                          setotherchr(newValue);
                        } else {
                          // For invalid values, show alert but don't update state
                          e.preventDefault(); // Prevent default behavior
                          alert(
                            `Entered Other Charges cannot be more than due amount ($${totalother_charges})`
                          );
                          // Keep the previous value by not calling setotherchr
                        }
                      }}
                    />
                  </div>
                </div>

                {/* <div className="accounting-service-item">
                <div className="accounting-service-info">
                  <div className="accounting-service-checkbox">
                    <label
                      htmlFor="service-7"
                      className="accounting-service-label"
                    >
                      <span className="accounting-service-name">Discount</span>
                    </label>
                  </div>
                </div>
                <div className="accounting-service-amount">
                  <span className="accounting-amount-due">- ${selectedDriver?.booking_data?.balance_discount || 0}</span>
                  <input
                    readOnly
                    style={{ opacity: "0" }}
                    name="useddiscount"
                    type="text"
                    id="amount-7"
                    className="accounting-amount-input"
                    placeholder="Amount"
                    defaultValue={selectedDriver?.booking_data?.balance_discount}
                  />
                </div>
              </div> */}

                <div className="accounting-service-total">
                  <div>
                    <span className="accounting-total-label">Total Amount</span>
                  </div>
                  <div>
                    <span className="accounting-total-amount">$</span>
                    <span className="accounting-total-amount totlamt">
                      {totalamount}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div className="accounting-payment-notes">
            <div className="accounting-notes-field">
              <label htmlFor="payment-notes" className="accounting-label">
                Payment Notes (Optional)
              </label>
              <textarea
                id="payment-notes"
                name="transaction_note"
                rows="3"
                className="accounting-textarea"
                placeholder="Add any notes regarding this payment..."
                onChange={(e) => setnotes(e.target.value)}
              ></textarea>
            </div>

            <div className="accounting-payment-actions">
              <div className="accounting-receipt-option"></div>

              <div className="accounting-form-buttons">
                <button
                  type="button"
                  className="accounting-btn accounting-btn-secondary"
                >
                  Cancel
                </button>
                <button
                  id="save-payment-btn"
                  type="button"
                  className={`accounting-btn accounting-btn-primary ${
                    bookingType == "2" &&
                    selectedDriver?.old_booking_data?.payment_cycle_switch !=
                      "0" &&
                    "disabledBtnPayment"
                  }`}
                  onClick={() =>
                    handleSaveChangesdynamic("createRightsForm", update_payment)
                  }
                >
                  Save Payment
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PaymentEntry;
